import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { PageHeader } from "@/components/Bits";
import api, { fmtZAR } from "@/lib/api";
import { FileText } from "lucide-react";

export default function QuotesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/quotes").then((r) => setItems(r.data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <PageHeader overline="Commercial" title="Quotes" description="All issued and approved quotes." />
        {loading ? <div className="overline">Loading…</div> : items.length === 0 ? (
          <div className="bq-card p-10 text-center"><FileText size={24} className="mx-auto text-[var(--bq-text-muted)]" /><div className="overline mt-3">No quotes</div></div>
        ) : (
          <div className="bq-card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-[var(--bq-bg)]">
                <tr>
                  <th className="text-left px-6 py-3 overline">Quote</th>
                  <th className="text-left px-6 py-3 overline">Estimator</th>
                  <th className="text-right px-6 py-3 overline">Total</th>
                  <th className="text-left px-6 py-3 overline">Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((q) => (
                  <tr key={q.id} className="border-t border-[var(--bq-border)] hover:bg-[var(--bq-bg)]" data-testid={`quote-row-${q.id}`}>
                    <td className="px-6 py-4 font-mono text-xs">{q.id.slice(0, 12)}</td>
                    <td className="px-6 py-4">{q.estimator_name || "—"}</td>
                    <td className="px-6 py-4 text-right font-semibold">{fmtZAR(q.total)}</td>
                    <td className="px-6 py-4"><span className={`pill ${q.status === "approved" ? "pill-approved" : "pill-quote"}`}>{q.status}</span></td>
                    <td className="px-6 py-4 text-right">
                      <Link to={`/projects/${q.project_id}`} className="text-[var(--bq-orange)] font-semibold text-sm" data-testid={`open-quote-${q.id}`}>Open project →</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
